import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {isADate} from 'app/global/fieldvalidation';
import {DateConversationPipe} from 'app/main/pages/dashboard/date-conversation.pipe';
import * as moment from 'moment';
import {debounceTime, lastValueFrom, startWith} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {AddToContractControlFormHelper} from '../add-to-contract-control-modal.component';
import {IAutoFillUploadFile} from '../create-cc-by-ai-form/ai-cc-import.service';
import {IaiProcessedData} from '../iai-processed-data.interface';

const validPeriodLengths = ['7d', '14d', '21d', '1', '2', '3', '6', '12', '18', '24', '36', '48', '60', '120', '-1', '0'];

@Component({
  selector: 'app-period-renewal-form',
  templateUrl: './period-renewal-form.component.html',
  styleUrl: './period-renewal-form.component.scss'
})
export class PeriodRenewalFormComponent implements OnInit, IaiProcessedData {
  @Input() periodRenewalForm: FormGroup;
  @Input() aiProcessedData: IAutoFillUploadFile;

  private static readonly COMMON_DATE_FORMAT = 'YYYY-MM-DD';

  public readonly: boolean = false;
  public searchable: boolean = true;
  public chooseContractlength  = this._transloco.events$.pipe(
          startWith({
              type: 'translationLoadSuccess'
          }),
          filter(e => e.type === 'translationLoadSuccess' || e.type ==='langChanged'),
          map(() => {
              return  [
                  { label:  this._transloco.translate('Document - listview - Add to contract control - create contract card - other label in dropdown list'), value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - other label in dropdown list') , value: "-1" },
                  { label: this._transloco.translate('Document - listview - Add to contract control - create contract card - ongoing label in dropdown list'), value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - ongoing label in dropdown list'), value: "0" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - one week label in dropdown list') , value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - days label in dropdown list', {count: 7}), value: "7d" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - weeks label in dropdown list', {count:2}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - days label in dropdown list', {count: 14}), value: "14d" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - weeks label in dropdown list', {count:3}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - days label in dropdown list', {count: 21}), value: "21d" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - one month label in dropdown list'), value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - one month label in dropdown list'), value: "1" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:2}), value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 2}), value: "2" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:3}), value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 3}), value: "3" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:6}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 6}), value: "6" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:12}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 12}), value: "12" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:18}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 18}), value: "18" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:24}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 24}), value: "24" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:36}), value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 36}), value: "36" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count:48}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 48}), value: "48" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - years label in dropdown list', {count:5}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 60}), value: "60" },
                  { label:this._transloco.translate('Document - listview - Add to contract control - create contract card - years label in dropdown list', {count:10}),  value_label: this._transloco.translate('Document - listview - Add to contract control - create contract card - month label in dropdown list', {count: 120}), value: "120" }
              ]
          }),
      );
  public chooseDaysMonth = [
    { label: this._transloco.translate('Document - listview - Add to contract control - create contract card - Month(s) label in dropdown list'), value: 'm' },
    { label: this._transloco.translate('Document - listview - Add to contract control - create contract card - Day(s) label in dropdown list'), value: 'd' }
  ];

  constructor (private _dateConversationPipe$: DateConversationPipe, private _transloco: TranslocoService, private _addToContractControlFormHelper:AddToContractControlFormHelper ) {}


   initializeWithAIProcessedData(aiProcessedData: IAutoFillUploadFile): void {
      const defaultForm = this._addToContractControlFormHelper.getPeriodRenewalForm().value;
      const startDate = isADate(aiProcessedData?.period.start_date) ? this.mapDateToGivenFormat(aiProcessedData?.period?.start_date)  : null;
      const endDate = this.getEndDateFromAI(aiProcessedData);
      const ai_contract_length = aiProcessedData.period?.contract_length?.toString().trim().toLocaleLowerCase();
      const ai_contract_length_renew = aiProcessedData?.period?.contract_length_renew?.toString().trim().toLocaleLowerCase();
      const ai_notice_period = this.matchPeriodLengthToContractLength(aiProcessedData?.period?.notice_period);  
      const ai_notice_renew = isNaN(Number( aiProcessedData.period?.notice_renew )) ? null : Number(aiProcessedData.period?.notice_renew);
      const ai_notice_period_renew= this.matchPeriodLengthToContractLength(aiProcessedData.period?.notice_period_renew);
             
        this.periodRenewalForm.patchValue({
            start_date: this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('start_date'), startDate ?? defaultForm.start_date  ) ,
            contract_length:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('contract_length'), validPeriodLengths.includes(ai_contract_length) ? ai_contract_length : defaultForm.contract_length  ) ,
            notice:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('notice'),   aiProcessedData.period?.notice ?? defaultForm.notice ) ,
            notice_period:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('notice_period'),  ai_notice_period ?? defaultForm.notice_period ) ,
            end_date:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('end_date'), endDate ?? defaultForm.end_date  ) ,
            auto_renew:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('auto_renew'), aiProcessedData?.period?.auto_renew ?? defaultForm.auto_renew  ) ,
            contract_length_renew:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('contract_length_renew'),  validPeriodLengths.includes(ai_contract_length_renew) ? ai_contract_length_renew :defaultForm.contract_length_renew )   ,
            notice_renew:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('notice_renew'), ai_notice_renew ?? defaultForm.notice_renew  ) ,
            auto_renewal_date:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('notice_renew'), aiProcessedData.period?.auto_date_renew ?? defaultForm.auto_renewal_date   ) ,
            notice_period_renew:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('notice_period_renew'),   ai_notice_period_renew?? defaultForm.notice_period_renew ),
            other_length_renew:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('other_length_renew'),   aiProcessedData.period?.other_length_renew ?? defaultForm.other_length_renew) ,
            other_length_period_renew:  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(this.periodRenewalForm.get('other_length_period_renew'), aiProcessedData.period?.other_length_period_renew  ?? defaultForm.other_length_period_renew  ) ,
        });

       this.extractContractPeriodLength();
    }
    
    private matchPeriodLengthToContractLength(periodLength: string): string {
     const matchedData = this.chooseDaysMonth?.find(x => x?.value?.trim().toLowerCase() === periodLength?.trim().toLowerCase());
     
      return matchedData?.value ?? null; 
    }

    private mapDateToGivenFormat(date: string): string | null {
        const momentDate = moment(date, PeriodRenewalFormComponent.COMMON_DATE_FORMAT, true);
        if (!momentDate.isValid()) {
            return null; // Return null if the date is invalid
        }
        return momentDate.format(PeriodRenewalFormComponent.COMMON_DATE_FORMAT);
    }



    private getEndDateFromAI(processedData:IAutoFillUploadFile){
      if(processedData.period.contract_length == '-1'){ // end date can be set manually only for contract length: other 
       return isADate(processedData.period?.end_date ) ? this.mapDateToGivenFormat(processedData.period?.end_date) : null;
      } 

      return null;
    }


  ngOnInit(): void {
    this.periodRenewalForm.get('start_date')?.valueChanges
    .pipe(debounceTime(300))
    .subscribe(() => {
      this.extractContractPeriodLength();
    });
  
  this.periodRenewalForm.get('end_date')?.valueChanges
    .pipe(debounceTime(300))
    .subscribe(() => {
      this.extractContractPeriodLength();
    });
  
  this.periodRenewalForm.get('contract_length')?.valueChanges
    .pipe(debounceTime(300))
    .subscribe(() => {
      this.extractContractPeriodLength();
  });

  this.periodRenewalForm.get('auto_renew')?.valueChanges
  .pipe(debounceTime(300))
  .subscribe(() => {
    this.extractContractPeriodLength();
  });

   if(this.aiProcessedData) {
       this.initializeWithAIProcessedData(this.aiProcessedData);
   }
  
  }




  get form(){
    return this.periodRenewalForm.controls;
  }



  
  /**
   * Patch Start date
   * @param $event 
   */
  async startDate($event) {
    const formatedDate = await lastValueFrom(this._dateConversationPipe$.transform($event.target?.value, 'date'));
    this.periodRenewalForm.patchValue({ start_date: formatedDate });
    this.periodRenewalForm.get('start_date').markAsDirty()
  }



  /**
   * Patch End date
   * @param $event 
   */
  async endDate($event) {
    const formatedDate = await lastValueFrom(this._dateConversationPipe$.transform($event.target?.value, 'date'));
    this.periodRenewalForm.patchValue({ end_date: formatedDate });
    this.periodRenewalForm.get('end_date').markAsDirty();
  }




  extractContractPeriodLength() {
    const startDate = this.periodRenewalForm.get('start_date')?.value;
    const endDate = this.periodRenewalForm.get('end_date')?.value;
    const currentDate = new Date();

    if (!endDate) {
        const contractLength = this.periodRenewalForm.get('contract_length')?.value;
        const periodLength = this.getNumericPart(contractLength);
        const periodUnit = this.getPeriodUnit(periodLength);
        const calculatedEndDate = this.calculateEndDate(startDate, periodLength, periodUnit);
        this.updateContractStatus(calculatedEndDate, currentDate, contractLength);
    } else {
        const parsedEndDate = new Date(endDate);
        this.updateContractStatus(parsedEndDate, currentDate);
    }
  }

  private getNumericPart(periodLength: string): number {
      return parseInt(periodLength.replace(/\D/g, ''), 10);
  }

  private getPeriodUnit(periodLength: number): moment.unitOfTime.DurationConstructor {
      return [7, 14, 21].includes(periodLength) ? 'days' : 'months';
  }

  private calculateEndDate(startDate: string, periodLength: number, periodUnit: moment.unitOfTime.DurationConstructor): Date {
      return moment(startDate).add(periodLength, periodUnit).toDate();
  }

  private updateContractStatus(endDate: Date, currentDate: Date, contractLength?: string): void {
      const isAutoRenewOn = this.periodRenewalForm.get('auto_renew').value === true;
      const isActive = (endDate > currentDate && contractLength !== '-1') || contractLength === '0' || isAutoRenewOn;

      if(this.periodRenewalForm.get('is_contract_active').dirty && this.periodRenewalForm.get('is_contract_active').touched){

        // we don't want to override user choice
        return;
      }else{
        this.periodRenewalForm.get('is_contract_active')?.setValue(isActive ? 1 : 0);
      }
  }
}
